var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "act-enter" }, [
    _c(
      "div",
      {
        staticClass: "main-con",
        style: { "background-color": _vm.imgShow ? "" : "#fafafa" },
      },
      [
        _vm.imgShow
          ? _c("img", {
              staticClass: "main-img",
              attrs: { src: _vm._f("imgPath")(_vm.imgUrl) },
              on: { error: _vm.handleError },
            })
          : _vm._e(),
        _c("div", { staticClass: "bottom-con" }, [
          _vm.type === "plus"
            ? _c("div", { staticClass: "discount" }, [
                _vm._v(" +" + _vm._s(_vm.discount)),
                _c("i", [_vm._v("%")]),
              ])
            : _vm._e(),
          _vm.type === "off"
            ? _c("div", { staticClass: "discount" }, [
                _vm._v(" " + _vm._s(_vm.discount)),
                _c("i", [_vm._v("%")]),
                _vm.$i18n.locale == "ar"
                  ? _c("i", [_vm._v("خصم")])
                  : _c("i", [_vm._v("OFF")]),
              ])
            : _vm._e(),
          _vm.timeShow && _vm.countdownResult
            ? _c(
                "div",
                { staticClass: "dead-line", style: { color: _vm.timeColor } },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.countdownResult.hours) +
                      ":" +
                      _vm._s(_vm.countdownResult.minutes) +
                      ":" +
                      _vm._s(_vm.countdownResult.seconds) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }